export class Authority {
  public empresaLoginId: number;
  public auth: string;
  constructor(empresaLoginId: number, auth: string) {
    this.empresaLoginId = empresaLoginId;
    this.auth = auth;
  }
}
